import { gql } from '@common/hooks';

export const WorksMembershipPermissions = gql`
  query WorksMembershipPermissions($id: ID!) {
    worksMembershipPermissions(id: $id) {
      key
      label
      enabled
      group
    }
  }
`;

export type WorksMembershipPermissionsQueryResponse = {
  worksMembershipPermissions: {
    key: string;
    label: string;
    enabled: boolean;
    group: string;
  }[];
};
